// The following list of domains should include anywhere we are listening for a message from window.postMessage.
// This list will ensure we filter out only those ones we want to listen for based on their e.origin value.
export const validSenders = () => {
  return [
    'http://localhost:8000',
    'https://backend-staging.marketwagon.com',
    'https://portal.marketwagon.com'
  ];
}
